(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ReduxOrm", [], factory);
	else if(typeof exports === 'object')
		exports["ReduxOrm"] = factory();
	else
		root["ReduxOrm"] = factory();
})(window, function() {
return 